import { useMemo } from 'react';
import { COMPOSITION_DIMENSIONS, VIDEO_QUALITY } from '@/player-config/src/constants/Remotion.constants';
import { SizeType } from '@/player-config/src/types/asset-types';

export default function usePlayerAspectRatio({ size }: { size: SizeType }) {
  const { compositionHeight, compositionWidth } = useMemo(() => {
    const videoQuality = VIDEO_QUALITY.FULL_HD;
    const compositionHeight = COMPOSITION_DIMENSIONS[size][videoQuality].HEIGHT;
    const compositionWidth = COMPOSITION_DIMENSIONS[size][videoQuality].WIDTH;

    return {
      compositionHeight,
      compositionWidth
    };
  }, [size]);

  return {
    compositionHeight,
    compositionWidth,
    playerAspectRatio: compositionWidth / compositionHeight
  };
}
